import { render, staticRenderFns } from "./EventsSingle.vue?vue&type=template&id=3071196b&scoped=true&"
import script from "./EventsSingle.vue?vue&type=script&lang=js&"
export * from "./EventsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071196b",
  null
  
)

export default component.exports